import { useState } from "react";
import { generateSelfSchedulingWindows, type SelfSchedulingWindow } from "./data";
import { useSelfSchedulingView } from "./ViewToggle";
import Windows from "./Windows";
import Shifts from "./Shifts";

const INITIAL_WINDOWS = generateSelfSchedulingWindows();

function SelfScheduling() {
    const [windows, setWindows] = useState<SelfSchedulingWindow[]>(INITIAL_WINDOWS);
    const [view] = useSelfSchedulingView();

    return view === "windows" ? (
        <Windows windows={windows} setWindows={setWindows} />
    ) : (
        <Shifts windows={windows} />
    );
}

export default SelfScheduling;
